// extracted by mini-css-extract-plugin
module.exports = {"container":"sf","block":"tf","subheading":"uf","cta":"vf","disabled":"wf","noBotMargin":"xf","light":"yf"};